const gteltTransformer = (word: string) => {
  const $gte = word;
  const $lt = `${word}\ufff0`;
  return { $gte, $lt };
};

export default gteltTransformer;
